module.exports = __webpack_public_path__ + "static/media/ValeDoLobo.a36e43b0.png";